import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";

// Pages
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import BillingPage from "@/pages/BillingPage";
import InventoryPage from "@/pages/InventoryPage";
import CustomersPage from "@/pages/CustomersPage";
import DoctorsPage from "@/pages/DoctorsPage";
import KhataPage from "@/pages/KhataPage";
import PassbookPage from "@/pages/PassbookPage";
import ReportsPage from "@/pages/ReportsPage";
import UsersPage from "@/pages/UsersPage";
import DoctorPanelPage from "@/pages/DoctorPanelPage";
import PurchasePage from "@/pages/PurchasePage";
import SaleReturnPage from "@/pages/SaleReturnPage";
import MRPartyLedgerPage from "@/pages/MRPartyLedgerPage";
import BeatManagementPage from "@/pages/BeatManagementPage";
import MasterSettingsPage from "@/pages/MasterSettingsPage";

// MR Pages
import MRHomePage from "@/pages/MRHomePage";
import MRBeatPage from "@/pages/MRBeatPage";
import MRExpensesPage from "@/pages/MRExpensesPage";
import MRGiftsPage from "@/pages/MRGiftsPage";
import MRVisitsPage from "@/pages/MRVisitsPage";
import MRProfilePage from "@/pages/MRProfilePage";
import MRKhataPage from "@/pages/MRKhataPage";

// Layouts
import AdminLayout from "@/components/admin/AdminLayout";
import MRLayout from "@/components/mr/MRLayout";

function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center" style={{ background: '#F9F9FA' }}><p style={{ color: '#8A94A6' }}>Loading...</p></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={user.role === 'mr' ? '/mr' : '/admin'} replace />;
  }
  return children;
}

function AuthRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center" style={{ background: '#F9F9FA' }}><p style={{ color: '#8A94A6' }}>Loading...</p></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === 'mr' ? '/mr' : '/admin'} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<AuthRedirect />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute allowedRoles={['admin', 'manager', 'cashier']}><AdminLayout /></ProtectedRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="billing" element={<BillingPage />} />
            <Route path="billing/new" element={<BillingPage />} />
            <Route path="billing/returns" element={<SaleReturnPage />} />
            <Route path="purchase" element={<PurchasePage />} />
            <Route path="inventory" element={<InventoryPage />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="doctors" element={<DoctorsPage />} />
            <Route path="khata" element={<KhataPage />} />
            <Route path="passbook" element={<PassbookPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="doctor-panel" element={<DoctorPanelPage />} />
            <Route path="beats" element={<BeatManagementPage />} />
            <Route path="master" element={<MasterSettingsPage />} />
          </Route>

          {/* MR Routes */}
          <Route path="/mr" element={<ProtectedRoute allowedRoles={['mr']}><MRLayout /></ProtectedRoute>}>
            <Route index element={<MRHomePage />} />
            <Route path="beat" element={<MRBeatPage />} />
            <Route path="expenses" element={<MRExpensesPage />} />
            <Route path="gifts" element={<MRGiftsPage />} />
            <Route path="visits" element={<MRVisitsPage />} />
            <Route path="profile" element={<MRProfilePage />} />
            <Route path="khata" element={<MRKhataPage />} />
            <Route path="party-ledger/:customerId" element={<MRPartyLedgerPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
